/* Master Tattoo Institute — shared interactions */
(function () {
  "use strict";

  /* ---------- Sticky header ---------- */
  const header = document.querySelector(".site-header");
  const onScrollHeader = () => {
    if (window.scrollY > 40) header.classList.add("scrolled");
    else header.classList.remove("scrolled");
  };
  window.addEventListener("scroll", onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- Scroll progress bar ---------- */
  const progress = document.querySelector(".scroll-progress");
  if (progress) {
    window.addEventListener(
      "scroll",
      () => {
        const h = document.documentElement;
        const pct = (h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100;
        progress.style.width = pct + "%";
      },
      { passive: true }
    );
  }

  /* ---------- Mobile nav ---------- */
  const toggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector(".main-nav");
  if (toggle && nav) {
    // Every top-level menu item with children renders its own .has-mega, so
    // collect them all — scoping to the first one left every later dropdown
    // navigating away instead of expanding.
    const megaItems = Array.from(nav.querySelectorAll(".has-mega"));
    const mobileNavActive = () => getComputedStyle(toggle).display !== "none";
    const closeMegas = () => megaItems.forEach((item) => item.classList.remove("open"));

    toggle.addEventListener("click", () => {
      toggle.classList.toggle("open");
      nav.classList.toggle("open");
      // reopening the menu should not show whatever was expanded last time
      if (!nav.classList.contains("open")) closeMegas();
      document.body.style.overflow = nav.classList.contains("open") ? "hidden" : "";
    });
    nav.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", (e) => {
        // A trigger is the direct child link of a .has-mega; links inside the
        // panel sit deeper, so they still navigate normally.
        const parent = a.parentElement;
        const isTrigger = parent && parent.classList.contains("has-mega");

        // on mobile, the mega trigger expands the accordion instead of navigating
        if (isTrigger && mobileNavActive()) {
          e.preventDefault();
          const wasOpen = parent.classList.contains("open");
          closeMegas(); // one section at a time
          if (!wasOpen) parent.classList.add("open");
          return;
        }
        toggle.classList.remove("open");
        nav.classList.remove("open");
        closeMegas();
        document.body.style.overflow = "";
      })
    );
  }

  /* ---------- Scroll reveal ---------- */
  const revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("visible"));
  }

  /* ---------- Animated counters ---------- */
  const counters = document.querySelectorAll("[data-count]");
  if (counters.length) {
    const animate = (el) => {
      const target = parseFloat(el.dataset.count);
      const suffix = el.dataset.suffix || "";
      const dur = 1800;
      const start = performance.now();
      const step = (now) => {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const cio = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            animate(e.target);
            cio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach((el) => cio.observe(el));
  }

  /* ---------- Accordion ----------
     Delegated from document so sections re-rendered by the Shopify
     theme editor stay interactive without re-binding. */
  document.addEventListener("click", (e) => {
    const head = e.target.closest(".acc-head");
    if (!head) return;
    const item = head.closest(".acc-item");
    const accordion = item && item.closest(".accordion");
    if (!item || !accordion) return;
    const body = item.querySelector(".acc-body");
    const isOpen = item.classList.contains("open");
    accordion.querySelectorAll(".acc-item.open").forEach((o) => {
      o.classList.remove("open");
      const ob = o.querySelector(".acc-body");
      if (ob) ob.style.maxHeight = null;
      const oh = o.querySelector(".acc-head");
      if (oh) oh.setAttribute("aria-expanded", "false");
    });
    if (!isOpen && body) {
      item.classList.add("open");
      body.style.maxHeight = body.scrollHeight + "px";
      head.setAttribute("aria-expanded", "true");
    }
  });

  /* ---------- Gallery lightbox ---------- */
  const lightbox = document.querySelector(".lightbox");
  if (lightbox) {
    const lbImg = lightbox.querySelector("img");
    document.addEventListener("click", (e) => {
      const item = e.target.closest(".gallery-item");
      if (!item) return;
      const img = item.querySelector("img");
      if (!img) return;
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt;
      lightbox.classList.add("open");
      document.body.style.overflow = "hidden";
    });
    const close = () => {
      lightbox.classList.remove("open");
      document.body.style.overflow = "";
    };
    lightbox.addEventListener("click", (e) => {
      if (e.target !== lbImg) close();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });
  }

  /* ---------- In-place video ----------
     Swaps a poster panel for its player without opening the modal. Delegated,
     so panels added by the theme editor work without re-binding. */

  /* Swapping in the player throws the poster markup away, template included.
     Keep the detached nodes so a caller can put the panel back the way it was
     — the tab switcher relies on this to stop a player it is about to hide. */
  const inlinePosters = new WeakMap();

  function restoreInlinePoster(panel) {
    const nodes = inlinePosters.get(panel);
    if (!nodes) return;
    panel.replaceChildren(...nodes);
    panel.classList.remove("is-playing");
    inlinePosters.delete(panel);
  }

  document.addEventListener("click", (e) => {
    const panel = e.target.closest("[data-video-inline]");
    if (!panel || panel.classList.contains("is-playing")) return;
    const tpl = panel.querySelector("template[data-video-player]");
    if (!tpl) return;
    inlinePosters.set(panel, Array.from(panel.childNodes));
    panel.replaceChildren(tpl.content.cloneNode(true));
    panel.classList.add("is-playing");
    track("video_play", { video_title: panel.getAttribute("data-video-title") || "" });
  });

  /* ---------- Background video loops ----------
     iOS only autoplays a muted video in place when the element itself carries
     `playsinline`, and Shopify's video_tag does not reliably emit it — without
     this a phone shows a frozen first frame. Force it (plus muted, since a
     browser will refuse an unmuted autoplay outright) and nudge playback.

     Templates are inert until cloned, so the with-sound modal players sitting
     in <template> are not matched here. */
  document.querySelectorAll("video[autoplay]").forEach((v) => {
    v.playsInline = true;
    v.muted = true;
    // A loop inside a tab that is not showing waits for its tab.
    const panel = v.closest(".ptab-panel");
    if (panel && !panel.classList.contains("active")) {
      v.pause();
      return;
    }
    const started = v.play();
    if (started && started.catch) started.catch(() => {});
  });

  /* ---------- Video modal ----------
     A tile carrying a <template data-video-player> plays it here. A tile
     without one falls back to the placeholder message. */
  const videoModal = document.querySelector(".video-modal");
  if (videoModal) {
    const titleEl = videoModal.querySelector("[data-vm-title]");
    const playerEl = videoModal.querySelector("[data-vm-player]");

    function closeVideoModal() {
      videoModal.classList.remove("open");
      document.body.style.overflow = "";
      // Emptying the container destroys the iframe / <video>, which is what
      // actually stops playback and audio.
      if (playerEl) playerEl.replaceChildren();
    }

    document.addEventListener("click", (e) => {
      // .video-frame is the strip tile; [data-video-open] lets any other
      // element (the video banner's play button) open the same modal.
      // Panels marked data-video-inline play in place instead — skip them.
      const frame = e.target.closest(".video-frame, [data-video-open]");
      if (!frame || frame.hasAttribute("data-video-inline")) return;

      const tpl = frame.querySelector("template[data-video-player]");
      if (titleEl) titleEl.textContent = frame.dataset.videoTitle || "Video";

      if (playerEl) {
        playerEl.replaceChildren();
        if (tpl) playerEl.appendChild(tpl.content.cloneNode(true));
      }
      videoModal.classList.toggle("has-video", Boolean(tpl && playerEl));

      videoModal.classList.add("open");
      document.body.style.overflow = "hidden";
    });

    videoModal.addEventListener("click", (e) => {
      if (e.target === videoModal || e.target.closest("[data-vm-close]")) closeVideoModal();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeVideoModal();
    });
  }

  /* ---------- Testimonial slider ----------
     Scoped per instance so the section can be added more than once
     from the Shopify theme editor. */
  function initSlider(slider) {
    const track = slider.querySelector(".testimonial-track");
    const dotsWrap = slider.parentElement.querySelector(".slider-dots");
    if (!track || !dotsWrap) return;

    const slides = track.children.length;
    if (slides === 0) return;

    let idx = 0;
    let timer;

    dotsWrap.innerHTML = "";
    for (let i = 0; i < slides; i++) {
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Go to testimonial " + (i + 1));
      b.addEventListener("click", () => go(i, true));
      dotsWrap.appendChild(b);
    }
    const dots = dotsWrap.querySelectorAll("button");

    function go(i, manual) {
      idx = (i + slides) % slides;
      track.style.transform = "translateX(-" + idx * 100 + "%)";
      dots.forEach((d, di) => d.classList.toggle("active", di === idx));
      if (manual) restart();
    }
    function restart() {
      clearInterval(timer);
      if (slides > 1) timer = setInterval(() => go(idx + 1), 6000);
    }
    go(0);
    restart();

    let startX = 0;
    track.addEventListener("touchstart", (e) => (startX = e.touches[0].clientX), { passive: true });
    track.addEventListener(
      "touchend",
      (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1), true);
      },
      { passive: true }
    );
  }

  /* ---------- Horizontal card rail ----------
     The row scrolls natively (and swipes on touch) with CSS scroll-snap; this
     only adds the desktop arrows and hides them when nothing overflows. */
  function initRail(rail) {
    const track = rail.querySelector("[data-rail-track]");
    if (!track) return;
    const prev = rail.querySelector("[data-rail-prev]");
    const next = rail.querySelector("[data-rail-next]");

    function sync() {
      const overflow = track.scrollWidth - track.clientWidth;
      rail.dataset.scrollable = overflow > 4 ? "true" : "false";
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= overflow - 2;
    }

    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -track.clientWidth, behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: track.clientWidth, behavior: "smooth" }));

    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    // images can change nothing here (columns are percentage based), but a
    // late webfont swap can — re-measure once everything has settled
    window.addEventListener("load", sync);
    sync();
  }

  function initSection(root) {
    root.querySelectorAll(".testimonial-slider").forEach(initSlider);
    root.querySelectorAll(".blog-rail").forEach(initRail);
  }

  initSection(document);

  /* Re-initialise when a section is re-rendered in the theme editor. */
  document.addEventListener("shopify:section:load", (e) => initSection(e.target));

  /* ---------- Form (front-end demo) ---------- */
  document.querySelectorAll("form[data-demo]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const success = document.querySelector(form.dataset.success || ".form-success");
      if (success) {
        form.style.display = "none";
        success.classList.add("show");
        success.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  });

  /* ---------- Vertical program tabs ----------
     Delegated so tab groups added or re-rendered in the theme editor work. */

  /* An inactive panel is display:none, but a hidden <video> keeps playing and a
     hidden iframe keeps its audio. Pause on the way out and start the muted
     loops again on the way in. A panel swapped to an in-place player goes back
     to its poster instead — that is the only way to stop a YouTube or Vimeo
     iframe without pulling in their player APIs. */
  function quietPanel(panel) {
    panel.querySelectorAll(".ptab-media.is-playing").forEach(restoreInlinePoster);
    panel.querySelectorAll("video").forEach((v) => v.pause());
  }

  function resumePanel(panel) {
    panel.querySelectorAll("video[autoplay]").forEach((v) => {
      const started = v.play();
      // Autoplay can still be refused (low-power mode); the poster stays put.
      if (started && started.catch) started.catch(() => {});
    });
  }

  function activateTab(tab) {
    const wrap = tab.closest("[data-tabs]");
    if (!wrap) return;
    const tabs = Array.from(wrap.querySelectorAll(".ptab"));
    const panels = Array.from(wrap.querySelectorAll(".ptab-panel"));
    const i = tabs.indexOf(tab);
    if (i < 0 || !panels[i]) return;
    if (tab.classList.contains("active")) return;

    tabs.forEach((t) => {
      t.classList.remove("active");
      t.setAttribute("aria-selected", "false");
    });
    panels.forEach((p) => {
      p.classList.remove("active");
      quietPanel(p);
    });
    tab.classList.add("active");
    tab.setAttribute("aria-selected", "true");
    panels[i].classList.add("active");
    resumePanel(panels[i]);

    if (window.gsap) {
      gsap.fromTo(
        panels[i],
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.55, ease: "power3.out", clearProps: "all" }
      );
      const img = panels[i].querySelector(".ptab-media img");
      if (img) gsap.fromTo(img, { scale: 1.12 }, { scale: 1, duration: 0.9, ease: "power3.out", clearProps: "all" });
    }
  }

  document.addEventListener("click", (e) => {
    const tab = e.target.closest(".ptab");
    if (tab) activateTab(tab);
  });

  document.addEventListener("keydown", (e) => {
    const tab = e.target.closest(".ptab");
    if (!tab) return;
    const wrap = tab.closest("[data-tabs]");
    if (!wrap) return;
    const tabs = Array.from(wrap.querySelectorAll(".ptab"));
    const i = tabs.indexOf(tab);
    let next = -1;
    if (e.key === "ArrowDown" || e.key === "ArrowRight") next = (i + 1) % tabs.length;
    else if (e.key === "ArrowUp" || e.key === "ArrowLeft") next = (i - 1 + tabs.length) % tabs.length;
    if (next < 0) return;
    e.preventDefault();
    tabs[next].focus();
    activateTab(tabs[next]);
  });

  /* ---------- Active nav link ----------
     Removed: the static build matched "about.html" style filenames.
     On Shopify the header section sets .active from Liquid via link.active,
     which is aware of the real route and of parent/child menu items. */

  /* ---------- Analytics events ----------
     One emitter for every tag setup: a dataLayer push covers Google Tag
     Manager, and gtag covers a GA4 tag installed directly. Neither being
     present is the normal state on a dev theme, so both are optional and the
     function is a no-op rather than an error.

     Event names are GA4's own (select_content, generate_lead, video_play) so
     they need no custom definitions to be usable in reports. */
  function track(name, params) {
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", name, params || {});
      }
    } catch (err) {
      /* analytics must never break the page */
    }
  }

  /* Any button or card link, without per-button setup in the theme editor.
     data-track on the element overrides the label when a stable name matters
     more than whatever the copy currently says. */
  document.addEventListener("click", (e) => {
    const el = e.target.closest("a.btn, a.card-link, [data-track]");
    if (!el) return;
    const section = el.closest(".shopify-section");
    track("select_content", {
      content_type: "cta",
      cta_label: el.getAttribute("data-track") || el.textContent.trim(),
      cta_url: el.getAttribute("href") || "",
      cta_section: section ? section.id.replace(/^shopify-section-/, "") : "",
    });
  });

  /* Shopify's contact form posts and reloads, so the submit event is the last
     moment this page can report anything. */
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/contact"]')) return;
    track("generate_lead", { form_id: form.id || "contact" });
  });

  /* Scroll depth, each threshold once. Uses the scrolled fraction of the
     scrollable distance rather than of page height, so a page shorter than the
     viewport reports 100 immediately instead of never reporting at all. */
  (function scrollDepth() {
    const marks = [25, 50, 75, 100];
    let sent = 0;
    let queued = false;

    function measure() {
      queued = false;
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      const pct = scrollable <= 0 ? 100 : ((window.scrollY / scrollable) * 100);
      while (sent < marks.length && pct >= marks[sent]) {
        track("scroll", { percent_scrolled: marks[sent] });
        sent++;
      }
      if (sent >= marks.length) window.removeEventListener("scroll", onScroll);
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    measure();
  })();
})();
